module.exports = __webpack_public_path__ + "img/img_supplier_kws@2x.041b5720.png";